import { render } from "./AccountOverview.vue?vue&type=template&id=63e5a804&scoped=true"
import script from "./AccountOverview.vue?vue&type=script&lang=js"
export * from "./AccountOverview.vue?vue&type=script&lang=js"

import "./AccountOverview.vue?vue&type=style&index=0&id=63e5a804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e5a804"]])

export default __exports__